// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c18e5902","453":"525074cc","455":"662e8825","977":"a5849ffb"}[chunkId] + ".chunk.js";
};